/* @index('./*.ts', f => `export * from '${f.path}';`) */
export * from './age.module';
export * from './age.pipe';
export * from './age.service';
/* @endindex */
